<div class="text-center">
    <button class="btn btn-sm btn-custom-pri" id="{{idString}}-editbtn-{{params.rowIndex}}"
        style="vertical-align: baseline; font-size: 12px;" (click)="handleActionClickEvent($event)"><i
            class="fa-solid fa-pen fa-fw"></i>
    </button>
</div>